import { makeObservable, observable } from 'mobx';
import { LayerConfigurationDto } from '../../types';

export default class LayerConfigurationModel {
    readonly showSubmissionToggle: boolean;
    skipSubmission: boolean;

    constructor(data: LayerConfigurationDto) {
        this.showSubmissionToggle = data.showSubmissionToggle;
        this.skipSubmission = data.skipSubmission;

        makeObservable(this, {
            skipSubmission: observable
        });
    }

    get dto(): LayerConfigurationDto {
        return {
            showSubmissionToggle: this.showSubmissionToggle,
            skipSubmission: this.skipSubmission
        };
    }
}
